import {createSelector, filter, groupBy, chain, nonNullable, keyBy} from 'helpers';
import * as activities from 'store/activities/selectors';
import {RootState} from 'store/root-state.type';

export const findTemplate = createSelector(
  createSelector(
    (state: RootState) => state.goals.templates,
    activities.templates,
    (goals, activities) => ({
      goals: keyBy(goals, goal => goal.name.toLowerCase()),
      activities: groupBy(activities, activity => activity.goal_id)
    })
  ),
  (templates) => (name?: string) => {
    const template = name ? templates.goals[name.toLowerCase()] : undefined;
    if (template) {
      const milestones = filter(templates.goals, milestone => milestone.parent_id === template.id);
      return {
        template,
        milestones,
        activities: chain(milestones)
          .map(milestone => templates.activities[milestone.id])
          .filter(nonNullable)
          .flatten()
          .value()
      }
    }
  }
);
